import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ILegalEntitiesService } from "services/LegalEntitiesService";
import { LegalEntityModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  LegalEntities: new Array<LegalEntityModel>(),
  Loading: false,
  LastUpdateTime: new Date(),
};

export const legalEntitySelectSlice = createSlice({
  name: "legalEntitySelect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getLegalEntities.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getLegalEntities.rejected, (state) => {
        state.Loading = false;
      })
      .addCase(getLegalEntities.fulfilled, (state, action) => {
        state.LegalEntities = action.payload;
        state.Loading = false;
        state.LastUpdateTime = new Date();
      });
  },
});

export const getLegalEntities = createAsyncThunk("LegalEntities/GetLegalEntities", async () => {
  const legalEntitiesService = container.get<ILegalEntitiesService>(SERVICE_TYPES.LegalEntitiesService);
  return await legalEntitiesService.getLegalEntities();
});

export const selectLegalEntities = (state: RootState) => {
  return state.legalEntitySelect.LegalEntities;
};
export const selectLoading = (state: RootState) => {
  return state.legalEntitySelect.Loading;
};
export const selectLastUpdateTime = (state: RootState) => {
  return state.legalEntitySelect.LastUpdateTime;
};

export default legalEntitySelectSlice.reducer;
